import backToTop from './modules/back-to-top';
import isi from './modules/isi';
import heroVideo from './modules/hero-video';
import homepageAnimation from './modules/homepage-animation';
import requestRepModal from './modules/request-rep-modal';
import scrollTagging from './modules/scroll-tagging';
import hcpOverlay from './modules/hcp-confirmation';

$(document).ready(function() {

  // allow Efficacy (parent) to be clickable in nav
  $('.dropdown > a span').on('click', function(e) {
    e.stopPropagation();
    window.location = 'efficacy';
  });

  // In iOS, it requires two taps for the submenu item to trigger. Force a redirect on the first tap. This was not done globally to avoid global errors. However, the issue may occur elsewhere, which would probably require this event listener to be applied more globally.
  $('.dropdown #nav-efficacy + .dropdown-menu a').on('click touchend', function() {
    var el = $(this);
    var link = el.attr('href');
    window.location = link;
  });

  // load homepage video & animations
  if (window.location.pathname === '/') {
    heroVideo();
    homepageAnimation();
  }

  // load ISI
  isi();

  // load back-to-top btn
  backToTop();

  // post request-a-rep info
  requestRepModal();

  // initialize scroll tagging
  scrollTagging();
  
  // initialize hcp confirmation overlay
  hcpOverlay();
});


// WEBPACK FOOTER //
// ./js/main.js